import { render } from "./index.vue?vue&type=template&id=0c811e50&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0c811e50&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0c811e50"

export default script